import React, { useEffect } from 'react';
import './psfomentops2024.css';
import { psfomentops2024 } from '../../json/psfomentops2024';

const Psfomentops2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa de "Fomento al Desarrollo de la<br />Participación Social para el Bienestar 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
   
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                El Programa de Fomento al Desarrollo de la Participación Social otorga apoyos económicos a personas artesanas integrantes de colectivos comunitarios, para el desarrollo de proyectos de difusión y venta artesanías, equipamiento y mantenimiento de talleres artesanales y para la preservación del patrimonio artesanal.
                </p>
                <p>
  
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6><br />
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Impulsar la participación de Colectivos Comunitarios integrados por un mínimo de 2 y hasta 20 personas artesanas para que, a través de la ejecución de proyectos contribuyan al fortalecimiento de las expresiones artesanales.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas artesanas integrantes de Colectivos Comunitarios de los 84 municipios del Estado de Hidalgo, agrupados en las 12 regiones contenidas en el Plan Estatal de Desarrollo 2022-2028, preferentemente de municipios de alta
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa tendrá cobertura en los 84 municipios del Estado de Hidalgo agrupados en las 12 regiones contenidas en el Plan Estatal de Desarrollo 2022-2028. Los apoyos se otorgarán conforme a la capacidad que permita la infraestructura y disponibilidad presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Participación Social y Fomento Artesanal<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Areli Maya Monsalvo: Subsecretaria de Participación Social y Fomento Artesanal
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 107 3952 y 771 107 39 58
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Fom_Des_PSocial_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reformas_ROP_Participacion_Social_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a>
                </li>
                </ul>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatoria</h5>
                <ul>
                <li>
                <a
                href='/assets/pdfs/convsspsfa_oct_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Noviembre 2024</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Formatos</h5>
                <ul>
                <li>
                <a
                href='/assets/pdfs/A1_Solicitud_Apoyo.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 1. Solicitud de Apoyo</a>
                </li>
                <li>
                <a
                href='/assets/pdfs/A2_Proyecto.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 2. Proyecto</a>
                </li>
                <li>
                <a
                href='/assets/pdfs/A3_Acta_Integración_Colectivo_Com.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 3. Acta de Integración del Colectivo Comunitario</a>
                </li>
                <li>
                <a
                href='/assets/pdfs/A4_Listado_Integrantes.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 4. Listado de Integrantes del Colectivo Comunitario</a>
                </li>
                <li>
                <a
                href='/assets/pdfs/A5_Carta_Compromiso.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 5. Carta Compromiso</a>
                </li>
                <li>
                <a
                href='/assets/pdfs/A6_Cuestionario_Socioeconómico.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexo 9. Cuestionario Socioeconómico</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de Folios Beneficiados</h5>
                <ul>
                <li>
                <a
                href='https://amigosdelatransformacion.com.mx/fa.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Noviembre 2024</a>
                </li>
                </ul>
                
              </div>
            </div>
            
          </div>
        </div>
     
      </div>    
    </div>
  );
};

export default Psfomentops2024;